export default __webpack_public_path__ + "static/media/sg-crest.24ba62e1.svg";